import React from "react";
import ReactDOM from "react-dom";
import Router from "./routes";
import { BrowserRouter } from "react-router-dom";
import i18n from "./config/i18n";
import { I18nextProvider } from "react-i18next";
import CSSReset from "@tds/core-css-reset";

ReactDOM.render(
  <React.StrictMode>
    <BrowserRouter>
      <I18nextProvider i18n={i18n}>
        <CSSReset />
        <Router />
      </I18nextProvider>
    </BrowserRouter>
  </React.StrictMode>,
  document.getElementById("root")
);
